import React from "react";
import { Button } from "./ui/button";

/**
 * Reusable empty state with optional CTA.
 * Pass `filtered` + `onClear` to render a "Clear filters" variant.
 */
export default function EmptyState({
    icon: Icon,
    title,
    description,
    ctaLabel,
    onCta,
    secondaryLabel,
    onSecondary,
    filtered,
    onClear,
    testid = "empty-state",
}) {
    return (
        <div className="p-10 flex flex-col items-center justify-center text-center" data-testid={testid}>
            {Icon && (
                <div className="h-12 w-12 rounded-full asl-navy-bg/10 flex items-center justify-center mb-3"
                    style={{ background: "var(--asl-navy-50)" }}>
                    <Icon className="h-6 w-6 asl-navy-text" />
                </div>
            )}
            <h3 className="text-base font-bold asl-navy-text">{title}</h3>
            {description && (
                <p className="text-sm text-[color:var(--asl-muted)] mt-1 max-w-md">{description}</p>
            )}
            <div className="flex items-center gap-2 mt-4">
                {filtered && onClear ? (
                    <Button variant="outline" size="sm" onClick={onClear} data-testid={`${testid}-clear`}>
                        Clear filters
                    </Button>
                ) : null}
                {ctaLabel && onCta ? (
                    <Button size="sm" className="asl-navy-bg text-white" onClick={onCta} data-testid={`${testid}-cta`}>
                        {ctaLabel}
                    </Button>
                ) : null}
                {secondaryLabel && onSecondary ? (
                    <Button variant="outline" size="sm" onClick={onSecondary} data-testid={`${testid}-secondary`}>
                        {secondaryLabel}
                    </Button>
                ) : null}
            </div>
        </div>
    );
}
